(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pl-collection-icons"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pl-collection-icons-carousel')) {
    customElements.define('pl-collection-icons-carousel', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.addEventListener('shopify:block:select', (event) => {
          const track = this.querySelector('.pl-collection-icons__track');
          const item = event.target.closest('.pl-collection-icons__item');
          const first = track?.firstElementChild;
          if (!item || !first || !track.contains(item)) return;
          const rtl = getComputedStyle(track).direction === 'rtl';
          const firstRect = first.getBoundingClientRect();
          const itemRect = item.getBoundingClientRect();
          const offset = rtl ? firstRect.right - itemRect.right : itemRect.left - firstRect.left;
          track.scrollTo({ left: rtl ? -offset : offset, behavior: 'auto' });
        }, { signal: this.controller.signal });
      }

      disconnectedCallback() {
        this.controller?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pl-collection-tiles"] && !Shopify.designMode) return;
  try {
    

  if (!customElements.get('pl-collection-tiles-carousel')) {
    customElements.define('pl-collection-tiles-carousel', class extends HTMLElement {
      connectedCallback() {
        this.initFrame = requestAnimationFrame(() => this.setup());
      }

      setup() {
        this.track = this.querySelector('.pl-collection-tiles__track');
        this.pagination = this.querySelector('.pl-collection-tiles__pagination');
        if (!this.isConnected || !this.track || !this.pagination) return;

        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.targets = [];
        this.track.addEventListener('scroll', () => {
          if (this.scrollFrame) return;
          this.scrollFrame = requestAnimationFrame(() => {
            this.scrollFrame = null;
            this.updateActiveDot();
          });
        }, { passive: true, signal });

        this.pagination.addEventListener('click', (event) => {
          const button = event.target.closest('[data-page-index]');
          if (!button || !this.pagination.contains(button)) return;
          const target = this.targets[Number(button.dataset.pageIndex)];
          if (target === undefined) return;
          this.track.scrollTo({
            left: this.rtl ? -target : target,
            behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
          });
        }, { signal });

        this.addEventListener('shopify:block:select', (event) => {
          const item = event.target.closest('.pl-collection-tiles__item');
          const first = this.track.firstElementChild;
          if (!item || !first || !this.track.contains(item)) return;
          const firstRect = first.getBoundingClientRect();
          const itemRect = item.getBoundingClientRect();
          const offset = this.rtl ? firstRect.right - itemRect.right : itemRect.left - firstRect.left;
          this.track.scrollTo({ left: this.rtl ? -offset : offset, behavior: 'auto' });
        }, { signal });

        this.resizeObserver = new ResizeObserver(() => this.refresh());
        this.resizeObserver.observe(this.track);
        if (this.track.firstElementChild) this.resizeObserver.observe(this.track.firstElementChild);
        this.refresh();
      }

      refresh() {
        const items = Array.from(this.track.children);
        const maxScroll = this.track.scrollWidth - this.track.clientWidth;
        const mobile = matchMedia('(max-width: 767px)').matches;
        this.pagination.hidden = !mobile || maxScroll <= 2 || items.length < 2;
        if (this.pagination.hidden) return;

        this.rtl = getComputedStyle(this.track).direction === 'rtl';
        const columns = Math.max(1, parseInt(getComputedStyle(this).getPropertyValue('--pl-tile-columns-mobile'), 10) || 2);
        const firstRect = items[0].getBoundingClientRect();
        this.targets = items.filter((_, index) => index % columns === 0).map((item) => {
          const rect = item.getBoundingClientRect();
          const offset = this.rtl ? firstRect.right - rect.right : rect.left - firstRect.left;
          return Math.min(Math.max(0, offset), maxScroll);
        }).filter((target, index, targets) => index === 0 || Math.abs(target - targets[index - 1]) > 2);

        if (this.pagination.children.length !== this.targets.length) {
          this.pagination.replaceChildren(...this.targets.map((_, index) => {
            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'pl-collection-tiles__dot';
            button.dataset.pageIndex = index;
            button.setAttribute('aria-controls', this.track.id);
            button.setAttribute('aria-label', this.dataset.pageLabel.replace('__page__', index + 1));
            return button;
          }));
        }
        this.updateActiveDot();
      }

      updateActiveDot() {
        if (this.pagination.hidden || !this.targets.length) return;
        const position = Math.abs(this.track.scrollLeft);
        const nearest = this.targets.reduce((closest, target, index) =>
          Math.abs(target - position) < Math.abs(this.targets[closest] - position) ? index : closest, 0);
        Array.from(this.pagination.children).forEach((button, index) => {
          if (index === nearest) button.setAttribute('aria-current', 'true');
          else button.removeAttribute('aria-current');
        });
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.initFrame);
        cancelAnimationFrame(this.scrollFrame);
        this.scrollFrame = null;
        this.controller?.abort();
        this.resizeObserver?.disconnect();
      }
    });
  }


  } catch(e) { console.error(e); }
})();
})();
